<template>
  <section>
    <!-- Introduction -->
    <v-row>
      <v-col cols="12">
        <p>
          During the year 2020, I've decided to challenge my coding skills by
          trying to acquire all the
          <a
            title="freeCodeCamp"
            href="https://www.freecodecamp.org/learn/"
            target="_blank"
            rel="noopener"
          >
            freeCodeCamp
          </a>
          certifications in a limited amount of time (2 months). This website
          proposes 7 different certifications, 6 of which are linked to web
          development curriculums, and one is acquired only if you succeed in
          getting all the other certifications. Each curriculum requires to create
          projects that fulfill certain conditions and proves that you know the
          concepts that have been taught.
        </p>
        <p>
          If you want to get accreditations for your competencies, those
          curriculums are the place to go. If you are new to the world of coding,
          this is a good place to start, especially for the front end development.
          I wouldn't recommend the more advanced courses like servers and APIs to
          beginners as they require certain coding practices and knowledge that
          you only acquire through experience.
        </p>
        <p>
          You can have access to all the submitted projects in my Github repository:
          <v-btn class="ml-5 white--text" color="black" href="https://github.com/QuentinMenDev/Freecodecamp-projects" target="_blank">Github repository</v-btn>
        </p>
        <p>List of certificates and projects:</p>
      </v-col>
    </v-row>

    <!-- Details section -->
    <v-row>
      <!-- Responsive Web Design Certification -->
      <v-col cols="12" sm="4">
        <v-row>
          <v-col>
            <a href="https://www.freecodecamp.org/certification/fccbc67975f-1335-48c9-bc1c-f8b00a2d298c/responsive-web-design" target="_blank">
              <v-img src="/img/certifications/webdev.png" />
            </a>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <p>
              <span class="text-h4">Responsive Web Design Certification</span>
              <ul class="text-body1">
                <li>Tribute Page project</li>
                <li>Survey Form project</li>
                <li>Product Landing Page project</li>
                <li>Technical Documentation project</li>
                <li>Personal Portfolio Webpage project</li>
              </ul>
            </p>
          </v-col>
        </v-row>
      </v-col>
      <!-- JavaScript Algorithms and Data Structures Certification -->
      <v-col cols="12" sm="4">
        <v-row>
          <v-col>
            <a href="https://www.freecodecamp.org/certification/fccbc67975f-1335-48c9-bc1c-f8b00a2d298c/javascript-algorithms-and-data-structures" target="_blank">
              <v-img src="/img/certifications/algorithms.png" />
            </a>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <p>
              <span class="text-h4">JavaScript Algorithms and Data Structures Certification</span>
              <ul class="text-body1">
                <li>Palindrome Checker project</li>
                <li>Roman Numeral Converter project</li>
                <li>Caesars Cipher project</li>
                <li>Telephone Number Validator project</li>
                <li>Cash Register project</li>
              </ul>
            </p>
          </v-col>
        </v-row>
      </v-col>
      <!-- Front End Libraries Certification -->
      <v-col cols="12" sm="4">
        <v-row>
          <v-col>
            <a href="https://www.freecodecamp.org/certification/fccbc67975f-1335-48c9-bc1c-f8b00a2d298c/front-end-libraries" target="_blank">
              <v-img src="/img/certifications/frontend.png" />
            </a>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <p>
              <span class="text-h4">Front End Libraries Certification</span>
              <ul class="text-body1">
                <li>Random Quote Machine project</li>
                <li>Markdown Previewer project</li>
                <li>Drum Machine project</li>
                <li>JavaScript Calculator project</li>
                <li>Pomodoro Clock project</li>
              </ul>
            </p>
          </v-col>
        </v-row>
      </v-col>
      <!-- Data Visualization Certification -->
      <v-col cols="12" sm="4">
        <v-row>
          <v-col>
            <a href="https://www.freecodecamp.org/certification/fccbc67975f-1335-48c9-bc1c-f8b00a2d298c/data-visualization" target="_blank">
              <v-img src="/img/certifications/datavisualization.png" />
            </a>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <p>
              <span class="text-h4">Data Visualization Certification</span>
              <ul class="text-body1">
                <li>Data Visualization with a Bar Chart project</li>
                <li>Data Visualization with a Scatterplot graph project</li>
                <li>Data Visualization with a Heat Map project</li>
                <li>Data Visualization with a Choropleth Map project</li>
                <li>Data Visualization with a Treemap Diagram project</li>
              </ul>
            </p>
          </v-col>
        </v-row>
      </v-col>
      <!-- APIs and Microservices Certification -->
      <v-col cols="12" sm="4">
        <v-row>
          <v-col>
            <a href="https://www.freecodecamp.org/certification/fccbc67975f-1335-48c9-bc1c-f8b00a2d298c/apis-and-microservices" target="_blank">
              <v-img src="/img/certifications/microservices.png" />
            </a>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <p>
              <span class="text-h4">APIs and Microservices Certification</span>
              <ul class="text-body1">
                <li>Timestamp Microservice project</li>
                <li>Request Header Parser Microservice project</li>
                <li>URL Shortener Microservice project</li>
                <li>Exercise Tracker project</li>
                <li>File Metadata Microservice project</li>
              </ul>
            </p>
          </v-col>
        </v-row>
      </v-col>
      <!-- Information Security and Quality Assurance Certification -->
      <v-col cols="12" sm="4">
        <v-row>
          <v-col>
            <a href="https://www.freecodecamp.org/certification/fccbc67975f-1335-48c9-bc1c-f8b00a2d298c/information-security-and-quality-assurance" target="_blank">
              <v-img src="/img/certifications/security.png" />
            </a>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <p>
              <span class="text-h4">Information Security and Quality Assurance Certification</span>
              <ul class="text-body1">
                <li>Metric-Imperial Converter project</li>
                <li>Issue Tracker project</li>
                <li>Personal Library project</li>
                <li>Stock Price Checker project</li>
                <li>Anonymous message Board project</li>
              </ul>
            </p>
          </v-col>
        </v-row>
      </v-col>

      <!-- FullStack Certification -->
      <v-col cols="12" sm="4">
        <v-row>
          <v-col>
            <a href="https://www.freecodecamp.org/certification/fccbc67975f-1335-48c9-bc1c-f8b00a2d298c/full-stack" target="_blank">
              <v-img src="/img/certifications/fullstack.png" />
            </a>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <p>
              <span class="text-h4">Full Stack Certification</span>
              <ul class="text-body1">
                <li>Responsive Web Design Certification</li>
                <li>JavaScript Algorithms and Data Structures Certification</li>
                <li>Front End Libraries Certification</li>
                <li>Data Visualization Certification</li>
                <li>APIs and Microservices Certification</li>
                <li>Information Security and Quality Assurance Certification</li>
              </ul>
            </p>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </section>
</template>

<script>
export default {};
</script>

<style></style>
